import axios from "axios";
import {BaseResponse} from "../../BaseResponse";
import {Retest} from "./getRetestList";

export async function putRetest(retest: Retest) {
    const response = await axios.put<BaseResponse<string>>(`/tank/retest/${retest.uid}`, retest)

    return response.data
}
